function setGParams() {
    const params = location.search;
	const searchParams = new URLSearchParams(params);

	for (const [key, value] of searchParams) {
		if (key.includes('gclid') || key.includes('utm_source') || key.includes('utm_medium')) {
            sessionStorage.setItem(key, value);
		}
	}
}

window.addEventListener('load', setGParams);
